import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDeclareMutation } from "../../services/auctionAPI";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import InputModal from "../../components/Modal/InputModal";

const CustomBreadCrumbs = ({ tournamentName, auctionId, onBack }) => {
  const [reason, setReason] = useState("");
  const [inputModal, setInputModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [declare] = useDeclareMutation();
  const navigate = useNavigate();
  const pause = async () => {
    const payload = {
      isPaused: true,
      isEnd: false,
      reason: reason,
      auctionId: auctionId,
    };
    try {
      const response = await declare(payload);
      if (response?.data?.success) {
        navigate("/auction/auction-details");
      }
    } catch (error) {
      setInputModal(false);
      toast.error(error?.data?.message || "Something went wrong");
    }
  };
  return (
    <Box>
      <Box sx={{ display: "flex", gap: "1rem", mt: "2rem" }}>
        <Button
          sx={{ border: "1px solid #E8ECF4", borderRadius: "1rem", py: 2 }}
          onClick={onBack ? onBack : () => setConfirm(true)}
        >
          <img src={icons.arrowleftBlack} alt="arrow" />
        </Button>
        <Box sx={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
          <Typography sx={{ fontWeight: "500", fontSize: "1.8rem" }}>
            Auction
          </Typography>
          <img
            src={icons.arrowrightBlack}
            alt="arrow"
            width={"15rem"}
            height={"15rem"}
          />
          <Typography
            sx={{
              background: colors.primary,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: "500",
              fontSize: "1.8rem",
            }}
          >
            {tournamentName}
          </Typography>
        </Box>
      </Box>
      <ConfirmModal
        open={confirm}
        onClose={() => setConfirm(false)}
        onConfirm={() => {
          setInputModal(true);
          setConfirm(false);
        }}
        title={"Are you sure you want to pause the Auction"}
      />
      <InputModal
        open={inputModal}
        onClose={() => {
          setInputModal(false);
        }}
        reason={reason}
        onConfirm={() => {
          if (!reason.trim()) {
            toast.warn("Enter the reason");
            return;
          }
          pause();
        }}
        setReason={setReason}
        title={"Reason for Auction Pausing"}
        placeholder={"Enter reason for auction pause"}
      />
    </Box>
  );
};

export default CustomBreadCrumbs;
